import { FormulaFieldRow } from './';
import { getRowKey } from '../';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { SelectionTable } from '@ui/tables';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { useApiResource, useSelectionTable } from '@hooks';
export const FormulaFieldSelectionTable = ({ parentIndex, resourceIdsUri, uri }) => {
    const { resource, loading } = useApiResource(uri);
    const selectionData = useSelectionTable({
        getRowKey,
        resourceIdsUri,
        results: resource,
        selectionType: SonarObjectType.SalesforceField
    });
    const renderRow = useCallback((item) => React.createElement(FormulaFieldRow, { formulaField: item, key: item.sonarObjectId, parentIndex: parentIndex }), [parentIndex]);
    return (React.createElement(SelectionTable, { dataSource: resource, loading: loading, renderRow: renderRow, rowKey: getRowKey, selectionData: selectionData, selectionType: PERISCOPE_TAB_TYPES.FORMULA_FIELDS }));
};
